import React, { createContext, useContext } from 'react';

// Create the context
const ProviderContext = createContext();

// Create the provider component
export function ProviderContextProvider({ children, providerId }) {
  return (
    <ProviderContext.Provider value={{ providerId }}>
      {children}
    </ProviderContext.Provider>
  );
}

// Create a custom hook to use the context
export function useProvider() {
  const context = useContext(ProviderContext);
  if (context === undefined) {
    throw new Error('useProvider must be used within a ProviderContextProvider');
  }
  return context;
}

export default ProviderContext; 